module.exports = __webpack_public_path__ + "img/供餐-1.12d92023.jpg";